(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  /* ================ FAQ Tab JS Start ================ */
  $('body').on('click', '.faq-tab-header:not(.not-tab) .btn', function (e) {
    e.preventDefault();
    var activeTab = $(this).attr('rel');
    if (!$(this).hasClass('active')) {
      $('.faq-tab-info').hide();
      $(`#${activeTab}`).fadeIn();
      $('.faq-tab-header:not(.not-tab) .btn').removeClass('active');
      $(this).addClass('active');
    }
  });

  $('body').on('click', '.faq-acc-header', function (f) {
    f.preventDefault();
    if ($(this).hasClass('active')) {
      $(this).removeClass('active');
      $(this).siblings('.faq-acc-body').slideUp(200);
    } else {
      $('.faq-acc-header').removeClass('active');
      $(this).addClass('active');
      $('.faq-acc-body').slideUp(200);
      $(this).siblings('.faq-acc-body').slideDown(200);
    }
  });
  /* ================ FAQ Tab JS End ================ */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
